module.exports = __webpack_public_path__ + "img/404.a74b1237.svg";